import { Controller } from "stimulus"

// Afficher / masquer les montants (masques par defaut).
//
//   <div data-controller="amounts">
//     <button type="button" data-action="amounts#toggle" data-amounts-target="button">
//       <i class="uil uil-eye" data-amounts-target="icon"></i>
//     </button>
//     <span data-amounts-target="value" data-amount="1 500 000 F"></span>
//   </div>
//
// Un seul controleur pilote tous les montants de la zone : un clic sur le bouton
// les affiche ou les masque ensemble.
export default class extends Controller {
  static targets = ["value", "button", "icon"]

  // Stimulus 2 ne gere pas les valeurs par defaut : le masque est une constante.
  get mask() {
    return "••••••"
  }

  connect() {
    this.visible = false
    this.render()
  }

  // Le cache de Turbolinks restaure la page telle quelle : on ne laisse jamais
  // les montants en clair dans une page mise en cache.
  disconnect() {
    this.visible = false
    this.render()
  }

  toggle(event) {
    event.preventDefault()
    this.visible = !this.visible
    this.render()
  }

  render() {
    this.valueTargets.forEach((element) => {
      element.textContent = this.visible ? element.dataset.amount : this.mask
      element.classList.toggle("is-masked", !this.visible)
    })

    const label = this.visible ? "Masquer les montants" : "Afficher les montants"

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-pressed", this.visible ? "true" : "false")
      this.buttonTarget.setAttribute("aria-label", label)
      this.buttonTarget.setAttribute("title", label)
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("uil-eye", !this.visible)
      this.iconTarget.classList.toggle("uil-eye-slash", this.visible)
    }
  }
}
